<template>
  <div>
    <editor
      v-model="content"
      @onChange="contentChanged"
      :api-key="apiKey"
      cloud-channel="8"
      :disabled="readOnly"
      :init="{
        height: boxHeight,

        plugins: [
          'accordion', 'anchor', 'autolink', 'autoresize', 'autosave', 'charmap', 'code', 'codesample', 'directionality', 'emoticons', 
          'fullscreen', 'help', 'image', 'importcss', 'insertdatetime', 'link', 'lists', 'lists advlist', 'media', 'nonbreaking', 
          'pagebreak', 'preview', 'quickbars', 'save', 'searchreplace', 'table', 'visualblocks', 'visualchars', 'wordcount'
        ],

        menubar: 'file edit insert view format table tools help',
        menu: {
          file: { title: 'File', items: 'newdocument restoredraft | preview | print' },
          edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall | searchreplace' },
          insert: { title: 'Insert', items: 'image link media codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor | insertdatetime' },
          view: { title: 'View', items: 'code | visualaid visualchars visualblocks | preview fullscreen ' },
          format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | removeformat' },
          table: { title: 'Table', items: 'inserttable | cell row column | tableprops deletetable' },
          tools: { title: 'Tools', items: 'code wordcount' },
          help: { title: 'Help', items: 'help' }
        },

        toolbar_mode: 'sliding',
        font_size_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
        toolbar1: 'fontsize | fontfamily | blocks',
        toolbar2:
          'undo redo | forecolor backcolor bold italic underline subscript superscript | ' +
          'alignleft aligncenter alignright alignjustify | ' +
          'bullist numlist outdent indent | link unlink | table image | removeformat code | fullscreen' 
          + ' | formathtml'
          ,

        images_reuse_filename: true,
        images_upload_handler: sendFile,
        relative_urls: false,
        remove_script_host: true,
        extended_valid_elements: '*[*]',
        valid_elements: '*[*]',

        font_family_formats: 
          '굴림=굴림;굴림체=굴림체;궁서=궁서;궁서체=궁서체;돋움=돋움;돋움체=돋움체;바탕=바탕;바탕체=바탕체;나눔고딕=NanumGothic,serif;' +
          'Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;' +
          'Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;' +
          'Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;' +
          'Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;' +
          'Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats;',

        setup: (editor) => {
          editor.ui.registry.addButton('formathtml', {
            text: 'Format HTML',
            tooltip: 'Prettier 정렬 HTML 보기/수정',
            onAction: () => {
              this.openFormattedHtml(editor)
            }
          })

          editor.ui.registry.addMenuItem('formathtml', {
            text: 'Format HTML',
            onAction: () => {
              this.openFormattedHtml(editor)
            }
          })
        }

      }"
    />

    <!-- formatted Html 보기 -->
    <v-dialog v-model="htmlDialog" max-width="1200" scrollable>
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Formatted HTML</span>
          <div class="html-btn-group">
            <v-btn small @click="formatDialogHtml">정렬</v-btn>
            <v-btn small @click="copyFormattedHtml">복사</v-btn>
            <v-btn small color="primary" @click="applyFormattedHtml">적용</v-btn>
            <v-btn small @click="htmlDialog = false">닫기</v-btn>
          </div>
        </v-card-title>

        <v-card-text class="html-dialog-body">
          <v-textarea
            v-model="formattedHtml"
            outlined
            auto-grow
            rows="20"
            style="font-family: Consolas, Monaco, monospace; font-size: 14px;"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

// formatted Html 보기
// npm install prettier@2.8.8 --save
const prettier = require('prettier/standalone')
const parserHtml = require('prettier/parser-html')

export default {
  name: 'tinyEditor',
  props: ['value', 'box_height', 'show_menu', 'readonly'],
  components: {
    'editor': Editor
  },
  data() {
    return {
      content: this.value,
      boxHeight: this.box_height == null ? 350 : this.box_height,
      showMenu: this.show_menu == null ? false : this.show_menu == 'Y' ? true : false,
      readOnly: this.readonly == null ? false : this.readonly,
      apiKey: this.$store.state.tinyApiKey,

      htmlDialog: false,
      formattedHtml: '',
      editorInstance: null
    }
  },
  created() {

    console.log("readonly : ", this.readonly, this.readOnly);
    
  },
  watch: {
    value(newValue) {
      this.content = newValue;
    },
    readonly(newValue) {
      this.readOnly = newValue;
    }
  },
  methods: {
    contentChanged() {
      // console.log("editor content changed:", this.content);
      // this.$emit('changed');
      this.$emit('input', this.content);
    },
    sendFile(blobInfo) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('fileData', blobInfo.blob(), blobInfo.filename());
        this.$http.post("/common/uploadTinyImg", formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then((res) => {
          if (res.data.code == 0) {
            resolve(res.data.img_path);
          } else {
            reject('이미지 업로드에 실패했습니다.');
          }
        }).catch((error) => {
          console.log(error);
          reject('이미지 업로드 중 오류가 발생했습니다: ' + error.message);
        });
      });
    },

    // formatted html 보기
    formatHtml(html) {
      try {
        const formatted = prettier.format(html || '', {
          parser: 'html',
          plugins: [parserHtml],
          tabWidth: 2,
          useTabs: false,
          printWidth: 120,
          htmlWhitespaceSensitivity: 'css'
        })
        console.log("formatted : ", formatted);
        return formatted;
      } catch (e) {
        console.error('HTML format error:', e)
        return html
      }
    },

    openFormattedHtml(editor) {
      try {
        this.editorInstance = editor
        const html = editor.getContent()
        this.formattedHtml = this.formatHtml(html)
        this.htmlDialog = true
      } catch (e) {
        console.error('Open formatted HTML error:', e)
      }
    },

    formatDialogHtml() {
      try {
        this.formattedHtml = this.formatHtml(this.formattedHtml)
      } catch (e) {
        console.error('Dialog format error:', e)
      }
    },

    applyFormattedHtml() {
      try {
        if (!this.editorInstance) {
          alert('에디터 인스턴스를 찾을 수 없습니다.')
          return
        }

        this.editorInstance.setContent(this.formattedHtml || '')
        this.content = this.editorInstance.getContent()
        this.$emit('input', this.content)
        this.htmlDialog = false
      } catch (e) {
        console.error('Apply formatted HTML error:', e)
        alert('HTML 적용 중 오류가 발생했습니다.')
      }
    },

    copyFormattedHtml() {
      if (!this.formattedHtml) return

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.formattedHtml)
          .then(() => {
            alert('복사되었습니다.')
          })
          .catch((err) => {
            console.log(err)
            this.fallbackCopy()
          })
      } else {
        this.fallbackCopy()
      }
    },

    fallbackCopy() {
      const textarea = document.createElement('textarea')
      textarea.value = this.formattedHtml
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()

      try {
        document.execCommand('copy')
        alert('복사되었습니다.')
      } catch (err) {
        console.log(err)
        alert('복사에 실패했습니다.')
      }

      document.body.removeChild(textarea)
    },

  }
}
</script>

<style scoped>
.html-btn-group .v-btn + .v-btn {
  margin-left: 10px;
}
.html-dialog-body {
  max-height: 70vh;
  overflow-y: auto;
  overscroll-behavior: contain;
}
</style>
